"use client";

import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "RR Recovery Solution helped me recover funds I didn't even know I had. Truly compassionate and trustworthy.",
  author: "Jane D.",
  position: "Satisfied Client"
}, {
  id: 2,
  quote: "Their integrity and care made all the difference. I highly recommend their services.",
  author: "Michael T.",
  position: "Happy Customer"
}, {
  id: 3,
  quote: "Professional, transparent, and genuinely caring. They guided me every step of the way.",
  author: "Sarah L.",
  position: "Recovered Funds"
}, {
  id: 4,
  quote: "I was skeptical at first, but they exceeded all my expectations. Highly ethical service.",
  author: "David R.",
  position: "Grateful Client"
}, {
  id: 5,
  quote: "Their faith-based approach and dedication to doing right by clients is unmatched.",
  author: "Emily K.",
  position: "Happy Customer"
}];
export default function ClientTestimonials() {
  const [api, setApi] = useState<CarouselApi>();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [isPaused, setIsPaused] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      if (!isPaused) {
        api.scrollNext();
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [api, isPaused]);
  const scrollPrev = () => {
    api?.scrollPrev();
  };
  const scrollNext = () => {
    api?.scrollNext();
  };
  return <>
        
        
      </>;
}